import { render, staticRenderFns } from "./SetupSchedule.vue?vue&type=template&id=4b9b1beb&scoped=true&"
import script from "./SetupSchedule.vue?vue&type=script&lang=js&"
export * from "./SetupSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9b1beb",
  null
  
)

export default component.exports